export default __webpack_public_path__ + "media/images/front/about/twitter-e8bbe7788826968194635a97195ff729.png";